<template>
  <div>
    <div class="flex flex-wrap -mx-2">

      <div class="w-full mb-3 px-2">
        <wz-input
          label="Dirección domiciliaria"
          v-model="form.address"
          placeholder="Ingresar dirección domiciliaria"
        />
      </div>

      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-select-search
          label="Ubigeo domicilio"
          v-model="form.ubigeo"
          :items="districts"
          defaultOption="Elegir ubigeo"
          search-placeholder="Buscar departamento, provincia o distrito..."
        />
      </div>

      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-select-search
          label="Ubigeo nacimiento"
          v-model="form.birthUbigeo"
          :items="districts"
          defaultOption="Elegir ubigeo nacimiento"
          search-placeholder="Buscar departamento, provincia o distrito..."
        />
      </div>

      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-input
          label="Teléfono personal"
          v-model="form.personalPhone"
          placeholder="Ingresar teléfono"
          maxlength="9"
          :error="v.personalPhone && v.personalPhone.$error
            ? (!v.personalPhone.numeric ? 'Teléfono debe ser numérico'
              : !v.personalPhone.mobile  ? 'Ingresa un teléfono válido de 9 dígitos' : '')
            : ''"
        />
      </div>

      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-input
          label="Correo personal"
          type="email"
          v-model="form.personalEmail"
          placeholder="Ingresar correo personal"
          :error="v.personalEmail && v.personalEmail.$error && !v.personalEmail.email
            ? 'Ingresa un correo electrónico válido' : ''"
        />
      </div>

    </div>

    <!-- Contacto de emergencia -->
    <div class="flex flex-wrap mt-2 -mx-2">
      <div class="w-full mb-2 px-2">
        <h2 class="form-subtitle">Contacto de emergencia</h2>
      </div>

      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-input
          label="Nombre del contacto"
          v-model="form.emergencyContact"
          placeholder="Ingresar nombre del contacto"
        />
      </div>

      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-select
          label="Parentesco"
          v-model="form.emergencyContactRelationship"
          :items="relationshipList"
          defaultOption="Elegir parentesco"
        />
      </div>

      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-input
          label="Teléfono de emergencia"
          v-model="form.emergencyPhoneNumber"
          placeholder="Ingresar teléfono de emergencia"
          maxlength="9"
          :error="v.emergencyPhoneNumber && v.emergencyPhoneNumber.$error
            ? (!v.emergencyPhoneNumber.numeric ? 'Teléfono debe ser numérico'
              : !v.emergencyPhoneNumber.mobile  ? 'Ingresa un teléfono válido de 9 dígitos' : '')
            : ''"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Constants } from '@/core/utils'

export default {
  props: {
    form:      { type: Object, required: true },
    v:         { type: Object, required: true },
    districts: { type: Array,  default: () => [] },
  },
  data() {
    return {
      relationshipList: Object.values(Constants.EmergencyRelationship),
    }
  },
}
</script>

<style lang="stylus" scoped></style>
